import "../App.css";
import { HomeSection } from "../sections/HomeSection";
import { AboutSection } from "../sections/AboutSection";
import { QuoteSection } from "../sections/QuoteSection";
import { ServeSection } from "../sections/ServeSection";
import { MentoringSection } from "../sections/MentoringSection";
import { Helmet } from "react-helmet";
import "../styles";

import "../menu.css";

function Home() {
  return (
    <>
      <Helmet>
        <title>
          Maya Mistress | Sensual Dominatrix in Amsterdam | London Tour
        </title>
        <meta
          name="description"
          content="Independent Professional Dominatrix based in Amsterdam. Power Dynamics Specialist. Sensual and Sadistic. Artist of Pleasure and Pain."
        />
        <meta
          name="keywords"
          content="Mistress Amsterdam, Dominatrix Amsterdam, Domina Amsterdam, BDSM Amsterdam, BDSM Mentorship, Online Femdom, Dominatrix for couples"
        />
        <link rel="canonical" href="https://mayamistress.nl" />
      </Helmet>
      <HomeSection />
      <AboutSection />
      <QuoteSection />
      <ServeSection />
      <MentoringSection />
      {/* <ProjectsSection /> */}
    </>
  );
}

export default Home;
